import { useState } from "react";
import { toast } from "sonner";
import { FileText, Paperclip, X } from "lucide-react";
import { AuthImage } from "@/components/damages/AuthImage";
import { api, errMsg } from "@/lib/api";

export const openFile = async (f) => {
  try {
    const { data } = await api.get(`/documents/files/${f.id}`, { responseType: "blob" });
    window.open(URL.createObjectURL(data), "_blank");
  } catch (e) { toast.error(errMsg(e)); }
};

export const DocFiles = ({ files, onRemove, testId }) => {
  const [zoom, setZoom] = useState(null);
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {files.map((f) => (
        <div key={f.id} className="relative">
          {f.content_type === "application/pdf" ? (
            <button type="button" onClick={() => openFile(f)} className="flex h-16 w-28 flex-col items-center justify-center gap-1 rounded-lg border border-rose-200 bg-rose-50 px-2 text-xs text-rose-700 hover:border-rose-400" data-testid={`doc-file-${f.id}`}>
              <FileText className="h-5 w-5" /><span className="w-full truncate text-center">{f.filename || "PDF"}</span>
            </button>
          ) : <AuthImage photoId={f.id} base="/documents/files" className="h-16 w-16 cursor-zoom-in rounded-lg" onClick={() => setZoom(f.id)} testId={`doc-file-${f.id}`} />}
          {onRemove && <button type="button" onClick={() => onRemove(f)} className="absolute -right-1 -top-1 rounded-full bg-white p-0.5 shadow" data-testid={`doc-file-remove-${f.id}`}><X className="h-3 w-3" /></button>}
        </div>
      ))}
      {!files.length && <span className="flex items-center gap-1 text-xs text-slate-400"><Paperclip className="h-3 w-3" /> Nessun allegato</span>}
      {zoom && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 p-4" onClick={() => setZoom(null)}>
          <AuthImage photoId={zoom} base="/documents/files" className="max-h-[90vh] max-w-full rounded-lg object-contain" />
        </div>
      )}
    </div>
  );
};
